import { useCallback } from "react";
import { useRouter } from "next/router";
import { AppShell } from "@/components/AppShell";
import { menu } from "@/components/dashboard/Sidebar";
import { Chats } from "@/components/ai/Chats";
import { okstatus } from "@/lib/utils";

const Page = () => {
  const router = useRouter();

  const handleNewThread = useCallback(() => {
    fetch("/api/ai/chat", {
      method: "POST"
    })
      .then(okstatus)
      .then(res => res.json())
      .then(data => {
        router.push("/chat/" + data.id);
      });
  }, [router]);

  return (
    <AppShell menuItem={menu.chat}>
      <Chats onNewThread={handleNewThread} />
    </AppShell>
  );
};

export default Page;
